import * as React from "react";
import { ClientResources, KitPopulationClient, PopulationSearchResultModel } from "@app/api2/api";
import { BPColumn } from "@common/BPReactTable";
import { PageHeader } from "@common/PageHeader";
import { buildUrl, AppRoutes } from "../AppRoutes";
import { getInactiveFilter } from "@common/Utils";
import { BPReactTable2, convertColumns, getFilterValue, useBpReactTable2 } from "../Common/DataTable/BPReactTable2";
import { BPDataTable3 } from "../Common/DataTable/BPDataTable3";
import { BPContainer } from "@/components/bp/bpcontainer";

interface PopulationsProps {
}

export class Populations extends React.Component<PopulationsProps> {
    client: KitPopulationClient = new KitPopulationClient();
    translationsContext: React.Context<ClientResources>;

    constructor(props) {
        super(props);

    }

    render() {
        const columns: BPColumn<PopulationSearchResultModel>[] = [
            getInactiveFilter('showInactive', window.translation.populationView.showInactive),
            {
                Header: window.translation.population.name,
                accessor: 'name',
                Cell: cell => <a href={cell.row.original.url}>{cell.value}</a>,
                width: "35%"
            },
            {
                Header: window.translation.common.lab,
                accessor: 'labName',
                Cell: cell => <>{cell.value}</>,
            },

        ];

        return (
            <BPContainer>
                <PageHeader header={window.translation.common.populations}
                    buttons={[
                        { label: window.translation.common.upload, to: buildUrl(AppRoutes.PopulationUpload, {}) },
                        { label: window.translation.populationView.createLocalPopulation, to: buildUrl(AppRoutes.PopulationCreateLocal, {}) }
                    ]}
                />
                <BPDataTable3
                    storeKey="Populations"
                    defaultSortField="name"
                    defaultSortAsc={true}
                    enableSearch={true}
                    dataSource={async (p) => {
                        let showInactive = p.filters.find(x => x.id == 'showInactive')?.value ?? false;

                        let pageData = await this.client.pageData(p.perPage, p.page, p.sortBy, p.sortDirection, p.searchValue, showInactive);
                        return pageData;
                    }}
                    columns={columns}
                    deletedSelector={(row) => !row.active}
                />
            </BPContainer>
        );
    }
}
let client = new KitPopulationClient();

export function Populations2(props: PopulationsProps) {

    const columns: BPColumn<PopulationSearchResultModel>[] = [
        getInactiveFilter('showInactive', window.translation.populationView.showInactive),
        {
            Header: window.translation.population.name,
            accessor: 'name',
            Cell: cell => <a href={cell.row.original.url}>{cell.value}</a>,
            width: "35%"
        },
        {
            Header: window.translation.common.lab,
            accessor: 'labName',
            Cell: cell => <>{cell.value}</>,
        },

    ];

    const columnsDef = convertColumns(columns);
    const table = useBpReactTable2<PopulationSearchResultModel>({
        columnDefs: columnsDef,
        queryKeyPrefix: 'Populations',
        query: async (paging, sorting, searchValue, filters) => {
            let showInactive = getFilterValue(filters, 'showInactive') ?? false as any;
            let pageData = await client.pageData(paging.pageSize, paging.pageIndex + 1, sorting[0]?.id, sorting[0]?.desc ? 'desc' : 'asc', searchValue, showInactive);
            return { rowCount: pageData.totalRows, rows: pageData.items }
        },
        defaultSortingState: [{ id: 'name', desc: false }],
    });

    return <BPContainer>
        <PageHeader header={window.translation.common.populations}
            buttons={[
                { label: window.translation.common.upload, to: buildUrl(AppRoutes.PopulationUpload, {}) },
                { label: window.translation.populationView.createLocalPopulation, to: buildUrl(AppRoutes.PopulationCreateLocal, {}) }
            ]}
        />
        <BPReactTable2
            {...table}
            deletedSelector={(row) => !row.active}
        />
    </BPContainer>
}

